import SubCategory from "features/SubCategory/SubCategoryList/SubCategory";

const SubCategoryPage: React.FC = () => {
  return <SubCategory/>;
};

export default SubCategoryPage;
